import React from 'react';
import { CompassIcon, LightbulbIcon, PencilLineIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  compass: CompassIcon,
  pencil: PencilLineIcon,
  bulb: LightbulbIcon,
  target: TargetIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-petrol" data-id="element-17" data-mp="3nnzzvfgjvgoy">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-18" data-mp="38rr5osbintje">
        <h2 id="beneficios" className="font-display text-[2rem] leading-none text-white sm:text-5xl" data-id="element-19" data-mp="3dr3sxe6av2mi">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-brand-ivory" data-id="element-20" data-mp="2ztoz7x90k8oq">
          Un estudio organizado puede ayudarte a conectar lo que antes parecía
          suelto.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="xy4szl5o06dn">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border border-brand-emerald bg-brand-petrol-light p-2.5 text-left" data-id="element-22" data-mp="2bdmgz622dl35" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-mint" data-id="element-23" data-mp="2g65r1t1jly37">
                  <Icon size={15} className="text-brand-petrol" data-id="element-24" data-mp="1sfjnof2hh1zj" />
                </span>
                <div data-id="element-25" data-mp="1of81gxuh2tly">
                  <h3 className="font-sub text-sm font-bold uppercase leading-tight text-brand-mint" data-id="element-26" data-mp="1ofrj0dg7nfzg">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-ivory sm:text-sm" data-id="element-27" data-mp="1xfo4653e5wpr">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}